import TermConditions from "components/widgets/WidgetBuilder/TermConditions";
import Terms from "components/widgets/WidgetBuilder/Terms";
import DynamicWidgetContext from "contexts/DynamicWidget";
import { TermTypes } from "models/DynamicWidget";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import utils from "services/utils";
import { updateTerms } from "services/widgetBuilder";
import { StyledWrapper } from "styled-components/Common/CommonStyled";

type WidgetTermsProps = {
	termList: TermTypes[];
	setTermList: (terms: TermTypes[]) => void;
	isSubmitting: boolean;
	setIsSubmitting: (value: boolean) => void;
};

const WidgetTerms = (props: WidgetTermsProps) => {
	const { t } = useTranslation();
	const { widgetDetails } = useContext(DynamicWidgetContext);
	const { metadata: { colors } = {} } = widgetDetails || {};
	const { highlight } = colors || {};
	const { termList = [], setTermList, isSubmitting, setIsSubmitting } = props;

	const [activeTerms, setActiveTerms] = useState();

	const closeTermConditionsModal = () => {
		setActiveTerms(undefined);

		// focus after closing term modal
		const terms = document.getElementById("terms");
		if (terms) {
			terms.setAttribute("tabindex", "0");
			terms.focus();
		}
	};

	const handleTermCheckbox = (checked: boolean, params: TermTypes) => {
		const { isTermsMandated } = params || {};

		let value = {
			required: !!isTermsMandated,
			checked,
		};
		const termsTemp = updateTerms(termList, params.id, value);
		const isCheckedAll = termsTemp.filter((item) => item.required).every((item) => item.checked);
		if (isCheckedAll) {
			setIsSubmitting(false);
		}
		setTermList([...termsTemp]);
	};

	const handleAgreeTerm = (id: number) => {
		const termsTemp = updateTerms(termList, id, {
			isAgreed: true,
			checked: true,
		});
		setTermList([...termsTemp]);
		setIsSubmitting(false);
		setActiveTerms(undefined);
	};

	return (
		<>
			<StyledWrapper margin="8px 0 0 0">
				<Terms
					terms={termList}
					handleTerms={handleTermCheckbox}
					setActiveTerms={setActiveTerms}
					isSubmitting={isSubmitting}
					highlight={highlight}
					margin="0"
				/>
			</StyledWrapper>

			{activeTerms && (
				<TermConditions
					isMobile={utils.isMobileWidth()}
					onClose={closeTermConditionsModal}
					terms={activeTerms}
					handleAgreeTerm={handleAgreeTerm}
					className={""}
					widgetInfo={widgetDetails}
					isNewLayout={true}
				/>
			)}
		</>
	);
};

export default WidgetTerms;
